import { type WorkType } from '@/libs/api'

/** 経由地 1 行分のフォーム値（地点未選択の行を含む） */
export type WaypointFormValue = {
  siteId: number | null
  note?: string | null
  /** 地点の絞り込みに使ったエリア（#4733、任意） */
  areaId?: number | null
  /** 経由地での作業内容（#4813、任意） */
  workType?: WorkType | null
  /**
   * 到着予定時刻（#5548、任意）。配車板のモーダルだけが入力欄を持つ。
   * 画面の入力は Date、API からの初期値は ISO 文字列で入る
   */
  entryTime?: Date | string | null
}

/** 到着予定時刻を API の送信形（ISO 文字列）へ。未入力・不正値は null */
const toEntryTimeIso = (
  value: Date | string | null | undefined
): string | null => {
  if (value == null || value === '') return null
  const date = value instanceof Date ? value : new Date(value)
  return Number.isNaN(date.getTime()) ? null : date.toISOString()
}

/**
 * 経由地のフォーム値を API の送信形（`{ siteId, note, areaId, workType, entryTime }` の
 * 訪問順配列）へ変換する。地点未選択の行は送らない。
 *
 * 作業内容は必ず送る。更新 API は経由地を丸ごと置き換えるため、要素に workType が無いと
 * BE が既定値（その他）に戻し、保存済みの選択が消える。
 * 到着予定時刻も同じ理由で必ず送る（未入力は null）。
 */
export const mapWaypointFormValuesToDto = (
  waypoints: WaypointFormValue[] | null | undefined
): {
  waypoints: {
    siteId: number
    note: string | null
    areaId: number | null
    workType: WorkType
    entryTime: string | null
  }[]
} => ({
  waypoints: (waypoints ?? [])
    .filter(
      (waypoint): waypoint is WaypointFormValue & { siteId: number } =>
        waypoint?.siteId != null
    )
    .map((waypoint) => ({
      siteId: waypoint.siteId,
      note: waypoint.note ?? null,
      areaId: waypoint.areaId ?? null,
      workType: waypoint.workType ?? 'OTHER',
      entryTime: toEntryTimeIso(waypoint.entryTime)
    }))
})
